import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAsObservableSource } from 'mobx-react-lite';
import { MarketLimitsState } from 'src/domains/sportsbook/trading/view/eventDetails/markets/marketsSettings/components/marketLimits/MarketLimits.state';
import { useAppStateContext } from 'src/AppState/AppState';
import Tabs from 'src/components/Tabs';
import { MarketId } from 'src_common/common/websocket2/id/WebsocketId';

export interface MarketLimitsPropsType {
    marketId: MarketId;
}

export const MarketLimits = observer('MarketLimits', (propsIn: MarketLimitsPropsType) => {
    const props = useAsObservableSource(propsIn);
    const appState = useAppStateContext();
    const [state] = useState(() => new MarketLimitsState(appState, props));

    return (<Tabs
        className='tabs__vertical tabs__betLimitsMap'
        key={`market-limits-${props.marketId.key}`}
        //active={state.activeTab}
    >

        <div
            key={`Prematch-${props.marketId.key}`}
            //@ts-expect-error
            label='Prematch limits'>
            <div className='row'>
                <div className='col-3'>
                    <div className={`element hasLabel ${state.prematchMaxBetError !== null ? 'invalid error' : ''}`} data-test='betLimitsMap.prematch.maxBet'>
                        <input
                            type='text'
                            name='betLimitsMap.prematch.maxBet'
                            value={state.prematchMaxBet}
                            onChange={state.onChangePrematchMaxBet}
                            onBlur={state.onSavePrematchMaxBet}
                        />
                        <label>Max bet</label>
                        {
                            state.prematchMaxBetError !== null ?
                                <div className='error-message'>
                                    <div className='error-message-content'>{state.prematchMaxBetError}</div>
                                </div> : null
                        }
                    </div>
                </div>
                <div className='col-3'>
                    <div className={`element hasLabel ${state.prematchLiabilityLimitError !== null ? 'invalid error' : ''}`} data-test='betLimitsMap.prematch.liabilityLimit'>
                        <input
                            type='text'
                            name='betLimitsMap.prematch.liabilityLimit'
                            value={state.prematchLiabilityLimit}
                            onChange={state.onChangePrematchLiabilityLimit}
                            onBlur={state.onSavePrematchLiabilityLimit}
                        />
                        <label>Liability limit</label>
                        {
                            state.prematchLiabilityLimitError !== null ?
                                <div className='error-message'>
                                    <div className='error-message-content'>{state.prematchLiabilityLimitError}</div>
                                </div> : null
                        }
                    </div>
                </div>
                <div className='col-3'>
                    <div className={`element hasLabel ${state.prematchMaxMultipleBetError !== null ? 'invalid error' : ''}`} data-test='betLimitsMap.prematch.maxMultipleBet'>
                        <input
                            type='text'
                            name='betLimitsMap.prematch.maxMultipleBet'
                            value={state.prematchMaxMultipleBet}
                            onChange={state.onChangePrematchMaxMultipleBet}
                            onBlur={state.onSavePrematchMaxMultipleBet}
                        />
                        <label>Max multiple bet</label>
                        {
                            state.prematchMaxMultipleBetError !== null ?
                                <div className='error-message'>
                                    <div className='error-message-content'>{state.prematchMaxMultipleBetError}</div>
                                </div> : null
                        }
                    </div>
                </div>
                <div className='col-3'>
                    <div className={`element hasLabel ${state.prematchMaxWinError !== null ? 'invalid error' : ''}`} data-test='betLimitsMap.prematch.maxWin'>
                        <input
                            type='text'
                            name='betLimitsMap.prematch.maxWin'
                            value={state.prematchMaxWin}
                            onChange={state.onChangePrematchMaxWin}
                            onBlur={state.onSavePrematchMaxWin}
                        />
                        <label>Max win</label>
                        {
                            state.prematchMaxWinError !== null ?
                                <div className='error-message'>
                                    <div className='error-message-content'>{state.prematchMaxWinError}</div>
                                </div> : null
                        }
                    </div>
                </div>
            </div>
        </div>
        ;
        <div
            key={`Show-${props.marketId.key}`}
            //@ts-expect-error
            label='Show limits'>
            <div className='row'>
                <div className='col-3'>
                    <div className={`element hasLabel ${state.showMaxBetError !== null ? 'invalid error' : ''}`} data-test='betLimitsMap.show.maxBet'>
                        <input
                            type='text'
                            name='betLimitsMap.show.maxBet'
                            value={state.showMaxBet}
                            onChange={state.onChangeShowMaxBet}
                            onBlur={state.onSaveShowMaxBet}
                        />
                        <label>Max bet</label>
                        {
                            state.showMaxBetError !== null ?
                                <div className='error-message'>
                                    <div className='error-message-content'>{state.showMaxBetError}</div>
                                </div> : null
                        }
                    </div>
                </div>
                <div className='col-3'>
                    <div className={`element hasLabel ${state.showLiabilityLimitError !== null ? 'invalid error' : ''}`} data-test='betLimitsMap.show.liabilityLimit'>
                        <input
                            type='text'
                            name='betLimitsMap.show.liabilityLimit'
                            value={state.showLiabilityLimit}
                            onChange={state.onChangeShowLiabilityLimit}
                            onBlur={state.onSaveShowLiabilityLimit}
                        />
                        <label>Liability limit</label>
                        {
                            state.showLiabilityLimitError !== null ?
                                <div className='error-message'>
                                    <div className='error-message-content'>{state.showLiabilityLimitError}</div>
                                </div> : null
                        }
                    </div>
                </div>
                <div className='col-3'>
                    <div className={`element hasLabel ${state.showMaxMultipleBetError !== null ? 'invalid error' : ''}`} data-test='betLimitsMap.show.maxMultipleBet'>
                        <input
                            type='text'
                            name='betLimitsMap.show.maxMultipleBet'
                            value={state.showMaxMultipleBet}
                            onChange={state.onChangeShowMaxMultipleBet}
                            onBlur={state.onSaveShowMaxMultipleBet}
                        />
                        <label>Max multiple bet</label>
                        {
                            state.showMaxMultipleBetError !== null ?
                                <div className='error-message'>
                                    <div className='error-message-content'>{state.showMaxMultipleBetError}</div>
                                </div> : null
                        }
                    </div>
                </div>
                <div className='col-3'>
                    <div className={`element hasLabel ${state.showMaxWinError !== null ? 'invalid error' : ''}`} data-test='betLimitsMap.show.maxWin'>
                        <input
                            type='text'
                            name='betLimitsMap.show.maxWin'
                            value={state.showMaxWin}
                            onChange={state.onChangeShowMaxWin}
                            onBlur={state.onSaveShowMaxWin}
                        />
                        <label>Max win</label>
                        {
                            state.showMaxWinError !== null ?
                                <div className='error-message'>
                                    <div className='error-message-content'>{state.showMaxWinError}</div>
                                </div> : null
                        }
                    </div>
                </div>
            </div>
        </div>;
        <div
            key={`InPlay-${props.marketId.key}`}
            //@ts-expect-error
            label='In play limits'>
            <div className='row'>
                <div className='col-3'>
                    <div className={`element hasLabel ${state.inPlayMaxBetError !== null ? 'invalid error' : ''}`} data-test='betLimitsMap.inPlay.maxBet'>
                        <input
                            type='text'
                            name='betLimitsMap.inPlay.maxBet'
                            value={state.inPlayMaxBet}
                            onChange={state.onChangeInPlayMaxBet}
                            onBlur={state.onSaveInPlayMaxBet}
                        />
                        <label>Max bet</label>
                        {
                            state.inPlayMaxBetError !== null ?
                                <div className='error-message'>
                                    <div className='error-message-content'>{state.inPlayMaxBetError}</div>
                                </div> : null
                        }
                    </div>
                </div>
                <div className='col-3'>
                    <div className={`element hasLabel ${state.inPlayLiabilityLimitError !== null ? 'invalid error' : ''}`} data-test='betLimitsMap.inPlay.liabilityLimit'>
                        <input
                            type='text'
                            name='betLimitsMap.inPlay.liabilityLimit'
                            value={state.inPlayLiabilityLimit}
                            onChange={state.onChangeInPlayLiabilityLimit}
                            onBlur={state.onSaveInPlayLiabilityLimit}
                        />
                        <label>Liability limit</label>
                        {
                            state.inPlayLiabilityLimitError !== null ?
                                <div className='error-message'>
                                    <div className='error-message-content'>{state.inPlayLiabilityLimitError}</div>
                                </div> : null
                        }
                    </div>
                </div>
                <div className='col-3'>
                    <div className={`element hasLabel ${state.inPlayMaxMultipleBetError !== null ? 'invalid error' : ''}`} data-test='betLimitsMap.inPlay.maxMultipleBet'>
                        <input
                            type='text'
                            name='betLimitsMap.inPlay.maxMultipleBet'
                            value={state.inPlayMaxMultipleBet}
                            onChange={state.onChangeInPlayMaxMultipleBet}
                            onBlur={state.onSaveInPlayMaxMultipleBet}
                        />
                        <label>Max multiple bet</label>
                        {
                            state.inPlayMaxMultipleBetError !== null ?
                                <div className='error-message'>
                                    <div className='error-message-content'>{state.inPlayMaxMultipleBetError}</div>
                                </div> : null
                        }
                    </div>
                </div>
                <div className='col-3'>
                    <div className={`element hasLabel ${state.inPlayMaxWinError !== null ? 'invalid error' : ''}`} data-test='betLimitsMap.inPlay.maxWin'>
                        <input
                            type='text'
                            name='betLimitsMap.inPlay.maxWin'
                            value={state.inPlayMaxWin}
                            onChange={state.onChangeInPlayMaxWin}
                            onBlur={state.onSaveInPlayMaxWin}
                        />
                        <label>Max win</label>
                        {
                            state.inPlayMaxWinError !== null ?
                                <div className='error-message'>
                                    <div className='error-message-content'>{state.inPlayMaxWinError}</div>
                                </div> : null
                        }
                    </div>
                </div>
            </div>
        </div>
    </Tabs>);
});
